export default {
  getPlatform: function getPlatform() {
    return 'web';
  }
};